import { path, identity, isObj, isFn, mapObj } from '@exah/utils';
import { DEFAULT_KEY, MEDIA_KEY, DEFAULT_MEDIA_KEY } from '../constants';
export var getTheme = function getTheme(props) {
  return props && props.theme || Object(props);
};
/**
 * ```js
 * import { themePath } from 'pss'
 * ```
 *
 * Get value from theme.
 *
 * @example
 * import { themePath } from 'pss'
 *
 * const Box = styled.div`
 *   width: ${themePath('size.card')};
 *   background-color: ${themePath('color.red', 'hotpink')};
 * `
 *
 * <Box /> // → width: 200px; background-color: hotpink;
 */

export var themePath = function themePath(input, defaultValue) {
  return function (props) {
    return path(input, defaultValue)(getTheme(props));
  };
};
export var getDefault = function getDefault(input, defaultValue) {
  if (defaultValue === void 0) {
    defaultValue = DEFAULT_KEY;
  }

  return themePath([DEFAULT_KEY, input], defaultValue);
};
export var getDefaultMedia = getDefault(MEDIA_KEY, DEFAULT_MEDIA_KEY);
export var getThemeMedia = function getThemeMedia(props) {
  var _Object$assign;

  return Object.assign((_Object$assign = {}, _Object$assign[getDefaultMedia(props)] = null, _Object$assign), path(MEDIA_KEY)(getTheme(props)));
};
export var getMedia = function getMedia(input, media) {
  return media ? path(input)(media) : function (props) {
    return path(input)(getThemeMedia(props));
  };
};
export function getThemeValue(themeKey, transformValue) {
  var isTransformValue = isFn(transformValue);

  if (!isTransformValue) {
    transformValue = identity;
  }

  return function (input, defaultValue, mediaKey) {
    return function (props) {
      var valueKey = input === true ? getDefault(themeKey)(props) : input;
      var themeData = themePath(themeKey)(props);
      var themeValue = path(valueKey)(themeData);

      if (Object(themeValue).hasOwnProperty(mediaKey)) {
        return transformValue(themeValue[mediaKey]);
      }

      if (isTransformValue && isObj(themeValue)) {
        return mapObj(function (key, value) {
          var _ref;

          return _ref = {}, _ref[key] = transformValue(themeValue[key]), _ref;
        }, themeValue);
      }

      return themeValue == null ? defaultValue : transformValue(themeValue);
    };
  };
}